import { Fragment, useContext, useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { AssessmentResult } from "../../Models/Assessment";
import { AssessmentCard } from "../../Assessments/AssessmentCard";
import { AuthContext } from "../../../Auth/AuthProvider";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AppliedToExamination } from "../Models/AppliedToExamination";

interface IProps{
    exam: AppliedToExamination;
}

export function ArticleExaminationCard(props: IProps) {

    const authContext = useContext(AuthContext);
    const [assessment, setAssessment] = useState<AssessmentResult>(null);

    useEffect(()=>{
        abpnClient.get<AssessmentResult>(`/api/physician/GetExamAssessment?examineeId=${props.exam.examineeId}`,authContext)
        .then(_=>{setAssessment(_)
        });
    },[]);

    return(
        assessment != null &&
        <Fragment>
            <Card className="mb-4" border="pp-secondary-grey">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-pp-primary">Assessment For Exam</span>
                    </Card.Title>
                    <Row className="mt-3">
                        <Col xs={12} md={12} lg={12} xl={12}>                        
                            <Fragment>
                                <AssessmentCard assessment={assessment} />                             
                            </Fragment>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            
        </Fragment>
    );
}